"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'equipment',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var url = 'WxOpen/getTemplateCodeList';
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res;
        //this.listQuery.page_num = res.page_num
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 生成模板
     */
    delTemplate: function delTemplate(row, index) {
      var _this2 = this;
      this.$alert('确定删除此模板代码？', '删除模板', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == "confirm") {
            _this2.$post('WxOpen/delTemplateCode', {
              template_id: row.template_id
            }).then(function (res) {
              _this2.$message({
                message: '删除成功',
                type: 'success'
              });
              _this2.list.splice(index, 1);
            });
          }
        }
      });
    }
  }
};